"use client";

import { useState } from "react";

export function ContactForm() {
  const [submitted, setSubmitted] = useState(false);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitted(true);
  }

  if (submitted) {
    return (
      <div className="text-center py-8">
        <div className="w-16 h-16 rounded-lg bg-success/10 flex items-center justify-center mx-auto mb-4">
          <svg
            className="w-8 h-8 text-success"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h2 className="font-serif text-xl font-bold text-charcoal mb-2">
          Message sent
        </h2>
        <p className="text-text-muted text-sm">
          Thanks for getting in touch. We will get back to you as soon as we
          can.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div>
        <label
          htmlFor="name"
          className="block text-sm font-medium text-text-body mb-1.5"
        >
          Name
        </label>
        <input
          id="name"
          name="name"
          type="text"
          required
          className="w-full px-4 py-3 bg-cream border-none rounded-sm text-sm text-text-body focus:outline-none focus:ring-2 focus:ring-forest/20"
        />
      </div>
      <div>
        <label
          htmlFor="email"
          className="block text-sm font-medium text-text-body mb-1.5"
        >
          Email
        </label>
        <input
          id="email"
          name="email"
          type="email"
          required
          className="w-full px-4 py-3 bg-cream border-none rounded-sm text-sm text-text-body focus:outline-none focus:ring-2 focus:ring-forest/20"
        />
      </div>
      <div>
        <label
          htmlFor="message"
          className="block text-sm font-medium text-text-body mb-1.5"
        >
          Message
        </label>
        <textarea
          id="message"
          name="message"
          rows={5}
          required
          className="w-full px-4 py-3 bg-cream border-none rounded-sm text-sm text-text-body focus:outline-none focus:ring-2 focus:ring-forest/20 resize-none"
        />
      </div>
      <button
        type="submit"
        className="w-full px-6 py-3.5 bg-forest text-white font-bold rounded-sm text-sm hover:bg-forest-light transition-colors border-none cursor-pointer"
      >
        Send Message
      </button>
    </form>
  );
}
